import { UVDRobotIcon } from "assets/icons/UVDRobotIcon";
import { UVDRobotUnassignedIcon } from "assets/icons/UVDRobotUnassignedIcon";
import { MenuItem } from "components/atoms/dashboard/menuItems/MenuItem";
import { MenuTitle } from "components/atoms/dashboard/menuItems/MenuTitle";
import { graphql } from "gql";
import {
  IoBusinessOutline,
  IoColorWand,
  IoGridOutline,
  IoPersonOutline,
} from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { ROUTES } from "routing/Routes";
import { useQueryWithSnack } from "utils/useQueryWithSnack";

export const SUPPORT_MENU_QUERY = graphql(`
  query SupportMenuItem {
    organizationCount
    robotCount(isActive: true)
    unassignedRobotCount: robotCount(isActive: false)
    identityCount
  }
`);

export const SupportMenuItem = () => {
  const { data } = useQueryWithSnack(SUPPORT_MENU_QUERY);

  return (
    <>
      <MenuTitle title="Support" hideSettings />
      <NavLink
        to={ROUTES.support.disinfections}
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => {
          return (
            <MenuItem
              hideCount
              isActive={isActive}
              value="Disinfections"
              icon={<IoGridOutline style={{ height: 20, width: 20 }} />}
            />
          );
        }}
      </NavLink>
      <NavLink
        to={ROUTES.support.organizations}
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => {
          return (
            <MenuItem
              isActive={isActive}
              value="Organizations"
              icon={<IoBusinessOutline style={{ height: 20, width: 20 }} />}
              count={data?.organizationCount || 0}
            />
          );
        }}
      </NavLink>
      <NavLink to={ROUTES.support.users} style={{ textDecoration: "none" }}>
        {({ isActive }) => {
          return (
            <MenuItem
              isActive={isActive}
              value="Users"
              icon={<IoPersonOutline style={{ height: 20, width: 20 }} />}
              count={data?.identityCount || 0}
            />
          );
        }}
      </NavLink>
      <NavLink to={ROUTES.support.robots} style={{ textDecoration: "none" }}>
        {({ isActive }) => {
          return (
            <MenuItem
              isActive={isActive}
              value="Robots"
              icon={<UVDRobotIcon />}
              count={data?.robotCount || 0}
            />
          );
        }}
      </NavLink>
      <NavLink
        to={ROUTES.support.unassignedRobots}
        style={{ textDecoration: "none" }}
      >
        {({ isActive }) => {
          return (
            <MenuItem
              isActive={isActive}
              value="Unassigned Robots"
              icon={<UVDRobotUnassignedIcon />}
              count={data?.unassignedRobotCount || 0}
            />
          );
        }}
      </NavLink>
    </>
  );
};
